




































































































































import { computed, defineComponent, ref, onMounted } from "@vue/composition-api";
import useContact from "@/store/useContact";
import ContactViewModel from "@/models/ContactViewModel";
import { VueTelInput } from "vue-tel-input";
import { profile as profilestore } from "@/store";

export default defineComponent({
    components: {
        VueTelInput,
        ConfirmDialog: () =>
            import(/* webpackChunkName: "settings" */ "./components/Dialogs/ConfirmDialog.vue")
    },
    setup(_, context) {
        const captainEmail = computed(() => {
            const email = profilestore.profile && profilestore.profile.userId;
            return email ? email.toLowerCase() : "";
        });
        const { add, nameRules, emailRules } = useContact({ captainEmail: captainEmail.value });

        const contactForm = ref<HTMLFormElement>();
        const valid = ref<boolean>(true);
        const showSuccess = ref<boolean>(false);
        const showStatus = ref<boolean>(false);
        const showLeaveConfirm = ref<boolean>(false);
        const statusTitle = ref<string>("Unable to add contact");
        const statusMessage = ref<string>("Please try again.");
        const name = ref<string>("");
        const email = ref<string>("");
        const vueTel = {
            phone: "",
            props: {
                autoFormat: true,
                autoDefaultCountry: true,
                dropdownOptions: {
                    showDialCodeInList: true,
                    showDialCodeInSelection: false,
                    showFlags: true,
                    showSearchBox: true,
                    width: '300px',
                },
                ignoredCountries: ["KP", "RU"],
                inputOptions: {
                    autocomplete: 'on',
                    showDialCode: true,
                    placeholder: 'Enterphone number',
                    required: true,
                },
                mode: "international",
                preferredCountries: ["DK", "NO", "SE"],
                validCharactersOnly: true,
            }
        };
        const detectorsActive = ref<boolean>(false);
        const shorePowerActive = ref<boolean>(false);
        const smartplugActive = ref<boolean>(false);
        const mainDoorActive = ref<boolean>(false);
        const hatchActive = ref<boolean>(false);
        const voltageLowActive = ref<boolean>(false);
        const geofenceActive = ref<boolean>(false);
        const lowBatteryActive = ref<boolean>(false);
        const gatewayTamperedActive = ref<boolean>(false);
        const gatewayPowerlossActive = ref<boolean>(false);
        const detectorsSMSActive = ref<boolean>(false);
        const shorePowerSMSActive = ref<boolean>(false);
        const smartplugSMSActive = ref<boolean>(false);
        const mainDoorSMSActive = ref<boolean>(false);
        const hatchSMSActive = ref<boolean>(false);
        const voltageLowSMSActive = ref<boolean>(false);
        const geofenceSMSActive = ref<boolean>(false);
        const lowBatterySMSActive = ref<boolean>(false);
        const gatewayTamperedSMSActive = ref<boolean>(false);
        const gatewayPowerlossSMSActive = ref<boolean>(false);
        const isValid = ref(false);

        const normalizeContactState = (state) => ({
            name: (state.name || "").trim(),
            email: (state.email || "").trim(),
            phoneNumber: (state.phoneNumber || "").trim(),
            detectorsActive: !!state.detectorsActive,
            shorePowerActive: !!state.shorePowerActive,
            smartplugActive: !!state.smartplugActive,
            mainDoorActive: !!state.mainDoorActive,
            hatchActive: !!state.hatchActive,
            voltageLowActive: !!state.voltageLowActive,
            geofenceActive: !!state.geofenceActive,
            lowBatteryActive: !!state.lowBatteryActive,
            gatewayTamperedActive: !!state.gatewayTamperedActive,
            gatewayPowerlossActive: !!state.gatewayPowerlossActive,
            detectorsSMSActive: !!state.detectorsSMSActive,
            shorePowerSMSActive: !!state.shorePowerSMSActive,
            smartplugSMSActive: !!state.smartplugSMSActive,
            mainDoorSMSActive: !!state.mainDoorSMSActive,
            hatchSMSActive: !!state.hatchSMSActive,
            voltageLowSMSActive: !!state.voltageLowSMSActive,
            geofenceSMSActive: !!state.geofenceSMSActive,
            lowBatterySMSActive: !!state.lowBatterySMSActive,
            gatewayTamperedSMSActive: !!state.gatewayTamperedSMSActive,
            gatewayPowerlossSMSActive: !!state.gatewayPowerlossSMSActive,
        });

        const buildContactState = () => ({
            name: name.value,
            email: email.value,
            phoneNumber: vueTel.phone,
            detectorsActive: detectorsActive.value,
            shorePowerActive: shorePowerActive.value,
            smartplugActive: smartplugActive.value,
            mainDoorActive: mainDoorActive.value,
            hatchActive: hatchActive.value,
            voltageLowActive: voltageLowActive.value,
            geofenceActive: geofenceActive.value,
            lowBatteryActive: lowBatteryActive.value,
            gatewayTamperedActive: gatewayTamperedActive.value,
            gatewayPowerlossActive: gatewayPowerlossActive.value,
            detectorsSMSActive: detectorsSMSActive.value,
            shorePowerSMSActive: shorePowerSMSActive.value,
            smartplugSMSActive: smartplugSMSActive.value,
            mainDoorSMSActive: mainDoorSMSActive.value,
            hatchSMSActive: hatchSMSActive.value,
            voltageLowSMSActive: voltageLowSMSActive.value,
            geofenceSMSActive: geofenceSMSActive.value,
            lowBatterySMSActive: lowBatterySMSActive.value,
            gatewayTamperedSMSActive: gatewayTamperedSMSActive.value,
            gatewayPowerlossSMSActive: gatewayPowerlossSMSActive.value,
        });

        const originalState = ref(normalizeContactState(buildContactState()));
        const pendingRoute = ref<null | ((allow?: boolean) => void)>(null);
        const allowLeave = ref(false);

        const setPendingRoute = (next) => {
            pendingRoute.value = next;
        };

        const hasUnsavedChanges = () =>
            !context.root.$_.isEqual(
                normalizeContactState(buildContactState()),
                originalState.value
            );

        onMounted(() => {
            originalState.value = normalizeContactState(buildContactState());
        });

        const phoneObject = function (object) {
            if (object.valid === true) {
                isValid.value = true;
            } else {
                isValid.value = false;
            }
        };

        const handleStatus = (status: number) => {
            if (status === 200) {
                showSuccess.value = true;
                return;
            }

            if (status === 403) {
                statusTitle.value = "Not allowed";
                statusMessage.value = "Only the captain can add sailor friends for this device.";
            } else if (status === 409) {
                statusTitle.value = "Duplicate email";
                statusMessage.value = "This email already exists for this device or belongs to a captain.";
            } else if (status === 400) {
                statusTitle.value = "Invalid email";
                statusMessage.value = "Please enter a valid email address.";
            } else {
                statusTitle.value = "Unable to add contact";
                statusMessage.value = "Please try again.";
            }

            showStatus.value = true;
        };

        const initSave = async () => {
            if (contactForm.value) {
                const isFormValid = contactForm.value.validate();
                if (isFormValid && isValid.value) {
                    const newContact = new ContactViewModel();
                    newContact.name = name.value;
                    newContact.email = email.value;
                    newContact.active = true;
                    newContact.phoneNumber = vueTel.phone;
                    newContact.detectorsEmailActive = detectorsActive.value;
                    newContact.shorePowerEmailActive = shorePowerActive.value;
                    newContact.smartplugEmailActive = smartplugActive.value;
                    newContact.mainDoorEmailActive = mainDoorActive.value;
                    newContact.hatchEmailActive = hatchActive.value;
                    newContact.voltageLowEmailActive = voltageLowActive.value;
                    newContact.geofenceEmailActive = geofenceActive.value;
                    newContact.lowBatterySensorEmailActive = lowBatteryActive.value;
                    newContact.gatewayTamperedEmailActive = gatewayTamperedActive.value;
                    newContact.gatewayPowerlossEmailActive = gatewayPowerlossActive.value;
                    newContact.detectorsSMSActive = detectorsSMSActive.value;
                    newContact.shorePowerSMSActive = shorePowerSMSActive.value;
                    newContact.smartPlugSMSActive = smartplugSMSActive.value;
                    newContact.mainDoorSMSActive = mainDoorSMSActive.value;
                    newContact.hatchSMSActive = hatchSMSActive.value;
                    newContact.voltageLowSMSActive = voltageLowSMSActive.value;
                    newContact.geofenceSMSActive = geofenceSMSActive.value;
                    newContact.lowBatterySensorSMSActive = lowBatterySMSActive.value;
                    newContact.gatewayTamperedSMSActive = gatewayTamperedSMSActive.value;
                    newContact.gatewayPowerlossSMSActive = gatewayPowerlossSMSActive.value;
                    newContact.gsmConnectionLostEmailActive = false; // never allow contacts to have this active
                    newContact.gsmConnectionLostSMSActive = false; // never allow contacts to have this active
                    const status = await add(newContact);
                    handleStatus(status);
                } else {
                    valid.value = isFormValid;
                }
            }
        };

        const successOk = () => {
            window.history.back();
        };

        const goBack = () => {
            if (hasUnsavedChanges()) {
                pendingRoute.value = null;
                showLeaveConfirm.value = true;
            } else {
                window.history.back();
            }
        };

        const leaveWithoutSaving = () => {
            allowLeave.value = true;
            if (pendingRoute.value) {
                const next = pendingRoute.value;
                pendingRoute.value = null;
                next();
            } else {
                window.history.back();
            }
        };

        return {
            contactForm,
            valid,
            name,
            email,
            vueTel,
            phoneObject,
            isValid,
            detectorsActive,
            shorePowerActive,
            smartplugActive,
            mainDoorActive,
            hatchActive,
            voltageLowActive,
            geofenceActive,
            lowBatteryActive,
            gatewayTamperedActive,
            gatewayPowerlossActive,
            detectorsSMSActive,
            shorePowerSMSActive,
            smartplugSMSActive,
            mainDoorSMSActive,
            hatchSMSActive,
            voltageLowSMSActive,
            geofenceSMSActive,
            lowBatterySMSActive,
            gatewayTamperedSMSActive,
            gatewayPowerlossSMSActive,
            nameRules,
            emailRules,
            showSuccess,
            showStatus,
            statusTitle,
            statusMessage,
            showLeaveConfirm,
            successOk,
            hasUnsavedChanges,
            setPendingRoute,
            goBack,
            leaveWithoutSaving,
            initSave
        };
    },
    beforeRouteLeave(to, from, next) {
        if (this.allowLeave) {
            next();
            return;
        }
        if (this.hasUnsavedChanges && this.hasUnsavedChanges()) {
            this.setPendingRoute(next);
            this.showLeaveConfirm = true;
        } else {
            next();
        }
    },
});
